<template>
  <PopUpModalStrip ref="popup">
    <!-- ------------ -->
    <!--  container   -->
    <!-- ------------ -->
    <div class="container-fluid">
      <div class="col p-3">
        <!-- -------------- -->
        <!--  main column   -->
        <!-- -------------- -->
        <div
          class="row bb-sub-hdg mt-1 mb-3 justify-content-center text-center"
        >
          {{ title }} [{{ row.name }}]
        </div>
        <!-- ---------------- -->
        <!--  row 1 = slots   -->
        <!-- ---------------- -->
        <div class="row">
          <div class="bb-slot-listing">
            <!-- ------------ -->
            <!--    slots     -->
            <!-- ------------ -->
            <div
              v-for="(slot, index) in slots"
              :key="index"
            >
              <div class="col-lg m-1">
                <FatigueLevelsPopup
                  v-if="isFatigueSelection"
                  :selected-level="slot.name"
                  inline
                >
                  <template #trigger>
                    <img
                      :id="index"
                      :src="slot.image"
                      class="img-fluid rounded bb-img-norm-border bb-hover"
                      @click="_confirm(index)"
                      alt="slot image"
                    />
                  </template>
                </FatigueLevelsPopup>
                <img
                  v-else
                  :id="index"
                  :src="slot.image"
                  class="img-fluid rounded bb-img-norm-border bb-hover"
                  @click="_confirm(index)"
                  alt="slot image"
                />
                <div
                  class="row bb-sub-sub-sub-hdg text-truncate mt-3 mb-2 justify-content-center text-center"
                >
                  {{ ucSlotName(slot.name) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ------------------ -->
        <!--  row 2 = buttons   -->
        <!-- ------------------ -->
        <div class="row mt-2 mb-2">
          <!-- ------------ -->
          <!--    buttons   -->
          <!-- ------------ -->
          <div
            class="btn-group special"
            role="group"
          >
            <!-- ------------ -->
            <!--    cancel    -->
            <!-- ------------ -->
            <button
              type="submit"
              @click="_cancel"
              class="btn btn-lg btn-warning"
            >
              Cancel
            </button>
            <!-- ------------ -->
            <!--      OK      -->
            <!-- ------------ -->
            <!-- <button
              type="submit"
              @click="_confirm"
              class="btn btn-lg btn-primary"
            >
              OK
            </button> -->
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </PopUpModalStrip>
</template>
<script>
import PopUpModalStrip from './PopUpModalStrip.vue'
import capitaliseFirstLetter from '../helpers/capitaliseFirstLetter'
import sleep from '../helpers/sleep'
import FatigueLevelsPopup from './FatigueLevelsPopup.vue'

export default {
  name: 'SelectionDialog',
  components: {
    FatigueLevelsPopup,
    PopUpModalStrip,
  },
  //=====================================================================
  // data
  //------
  data: () => ({
    slots: undefined,
    title: undefined,
    row: undefined,
    selected_slot_id: null,
    // okButton: "OK",
    cancelButton: 'Cancel',
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  computed: {
    isFatigueSelection() {
      return this.title === 'Fatigue'
    },
  },
  //=====================================================================
  // methods
  //---------
  methods: {
    ucSlotName(slotname) {
      return capitaliseFirstLetter(slotname)
    },
    show(opts = {}) {
      this.slots = opts.slots
      this.title = opts.title
      this.row = opts.row
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton
      }
      //
      this.$refs.popup.open()
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    //=====================================================================
    // highlight selected slot
    //-------------------------
    highlightSelectedSlot(index) {
      var el = document.getElementById(index)
      if (el) {
        el.style.borderStyle = 'solid'
        el.style.borderWidth = '4px'
        el.style.borderColor = 'white'
      }
    },
    //=====================================================================
    // confirm
    //---------
    _confirm(index) {
      this.highlightSelectedSlot(index)
      sleep(100).then(() => {
        this.$refs.popup.close()
        this.resolvePromise(this.slots[index])
      })
    },
    //=====================================================================
    // cancel
    //--------
    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise()
    },
  },
}
</script>
